export const state = {
  produtoVenda: {},
  produtosVenda: [],
  clienteVenda: {},
  venda: {
    id: null,
    status: "",
    subtotal: "0,00",
    desconto: "0,00",
    desconto_percentual: "0,00",
    total: "0,00",
    valor_pago: "0,00",
    troco: "0,00",
    cliente_id: "",
    formas_pagamento: [],
    cpf: "",
    cfop: "",
    valor_frete: 0,
    chave_nfe: "",
    numero_nfe: "",
    estado_nfe: "",
    path_xml: "",
    acrescimo: 0,
  },
  vendas: [],
  modalExcluirVenda: false,
  modalImprimirVenda: false,
  modalVisualizarVenda: false,
  descontoTotalPercentualVenda: 0,
  modalTrocaVenda: false,
  modalListarVenda: false,
  descontoAdicionalTotalVenda: "0,00",
  totalVendaComDescontoAdicional: "0,00",
  modalDescontoAdicionalVenda: false,
  modalExclusaoVenda: false,
  checklistProdutoVenda: ""
};

export default {};
